module.exports = __webpack_public_path__ + "img/zlpqk.dca600b5.png";